import type { ServiceDetail } from "@shyne/shared/api";
import { ReadAllResponse, uuid } from "@/interfaces";
import { activeOrganizationIdIfAny } from "@/lib/active-organization";
import { api } from "@/lib/api";
import { PhotoWorkflow } from "@/models/photo-workflow.model";

export const toPhotoWorkflowList = ({ id: service, photoSlots }: Pick<ServiceDetail, "id" | "photoSlots">): ReadAllResponse<PhotoWorkflow> => ({
  data: photoSlots.map((slot, index) => ({ id: slot.id, title: slot.title, description: slot.description, order: index + 1, service, created_at: "", updated_at: "" })),
  count: photoSlots.length,
});

export const PhotoWorkflowRepository = {
  async getAll(service: uuid): Promise<ReadAllResponse<PhotoWorkflow>> {
    return toPhotoWorkflowList(await api.services.get(service, { actingOrganization: activeOrganizationIdIfAny() }));
  },
  async create(service: uuid, { title, description }: { title: string; description?: string | null }): Promise<ReadAllResponse<PhotoWorkflow>> {
    return toPhotoWorkflowList(await api.services.addPhotoSlot(service, { title, description: description ?? null }));
  },
  async order(service: uuid, slots: readonly uuid[]): Promise<ReadAllResponse<PhotoWorkflow>> {
    return toPhotoWorkflowList(await api.services.orderPhotoSlots(service, { slots: [...slots] }));
  },
  async delete(service: uuid, slot: uuid): Promise<ReadAllResponse<PhotoWorkflow>> {
    return toPhotoWorkflowList(await api.services.deletePhotoSlot(service, slot));
  },
};
